export const getMergedTagSources = (
  tagsSources = {},
  operationSources = {},
  operationTimestampTags = {},
  navbarKpiSources = {},
  navbarButtonSources = {},
  alarmLiveSources = {},
) => {
  // Keep uniqueness per ship
  const merged = new Map();

  for (const [ship, arr] of Object.entries(tagsSources)) {
    merged.set(ship, new Set(arr || []));
  }
  for (const [ship, arr] of Object.entries(operationSources)) {
    if (!merged.has(ship)) merged.set(ship, new Set());
    for (const tag of arr || []) merged.get(ship).add(tag);
  }
  for (const [ship, arr] of Object.entries(operationTimestampTags)) {
    if (!merged.has(ship)) merged.set(ship, new Set());
    for (const tag of arr || []) merged.get(ship).add(tag);
  }
  for (const [ship, arr] of Object.entries(navbarKpiSources)) {
    if (!merged.has(ship)) merged.set(ship, new Set());
    for (const tag of arr || []) merged.get(ship).add(tag);
  }
  for (const [ship, arr] of Object.entries(navbarButtonSources)) {
    if (!merged.has(ship)) merged.set(ship, new Set());
    for (const tag of arr || []) merged.get(ship).add(tag);
  }
  // alarmLiveSources: { [tableKey]: { [ship]: [tag, ...] } }
  Object.values(alarmLiveSources).forEach(function (sourcesByShip) {
    Object.entries(sourcesByShip || {}).forEach(function ([ship, arr]) {
      if (!merged.has(ship)) merged.set(ship, new Set());
      (arr || []).forEach(function (tag) {
        merged.get(ship).add(tag);
      });
    });
  });

  return Object.fromEntries(Array.from(merged.entries(), ([ship, set]) => [ship, Array.from(set)]));
};

// build full payload for sendMessage
export const buildWsMessageData = (req = {}) => {
  if (!req?.tagsSources) return null;
  const op = req.operationSources ?? {};
  const tsTags = req.operationTimestampTags ?? {};
  const kpiSources = req.navbarKpiSources ?? {};
  const buttonSources = req.navbarButtonSources ?? {};
  const alarmLiveSources = req.alarmLiveSources ?? {};
  return {
    tagsSources: getMergedTagSources(
      req.tagsSources,
      op,
      tsTags,
      kpiSources,
      buttonSources,
      alarmLiveSources,
    ),
    msIntInterval: req.msIntInterval ?? 1000,
    emptyStringIgnoreOption: true,
  };
};
